import { render, staticRenderFns } from "./VNewReady.vue?vue&type=template&id=94f14ee0&"
import script from "./VNewReady.vue?vue&type=script&lang=js&"
export * from "./VNewReady.vue?vue&type=script&lang=js&"
import style0 from "./VNewReady.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports